import { useState } from 'react'
export interface BmsTag {
   id: number;
   name: string;
   created_at: string;
   updated_at: string;
   last_edited_by_user_id: number;
   active: boolean;
   type: string;
}
const tagType = 'product_tags'
export const useProductTags = ({ endpoint }: { endpoint: string }) => {
   const [tags, setTags] = useState<BmsTag[]>([])
   const fetchTags = async (token: string) => {
      if (!token) {
         return
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const searchQuery: { [key: string]: any; page: number } = { page: 0 };
      const data: BmsTag[] = [];

      // eslint-disable-next-line no-constant-condition
      while (true) {
         searchQuery.page += 1;
         const searchQueryString = new URLSearchParams(searchQuery)
         const searchUrl = `${endpoint}/v1/${tagType}/?${searchQueryString.toString()}`;

         const response = await fetch(searchUrl, {
            method: 'GET',
            headers: {
               Authorization: `Bearer ${token}`,
               Accept: 'application/json',
               'Content-Type': 'application/json',
            },
         });

         const result: BmsTag[] = await response.json();

         if (!result || !result[tagType] || result[tagType].length === 0) {
            break;
         }

         data.push(...result[tagType]);
      }
      setTags(data.map((t) => ({ ...t, type: tagType } as BmsTag)))
   }

   return { tags, fetchTags };
};